"use strict";
/**
 * Infrastructure Domain — DynamoDB Database Record Types
 *
 * Records for image caching, image processing status, image upload metadata,
 * and notification retry queue.
 */
Object.defineProperty(exports, "__esModule", { value: true });
// `ReviewBlockRecord` (`user#{id}` / `review_block`) was removed on 2026-09-08 with the rest of the
// review-submission cooldown — see the note in `src/api/review.ts` for the asymmetry and the window
// inversion a future reinstatement should know about. It had no importer even while the mechanism was
// live: `pattern-reviews.ts` built the block record as an inline object literal and never referenced
// this type, which is why the audit classified it `unused-symbol`.
